module.exports = __webpack_public_path__ + "img/filter-details2.38774912.png";